import { useNotificationSocket } from './useNotificationSocket'

/**
 * Renders nothing — just mounts `useNotificationSocket` from inside a
 * layout's own `<AxiosProvider>`/`<Outlet/>` tree. Mount once per
 * always-on authenticated app shell (e.g. `AlbumDesignRoot`, `DashboardLayout`)
 * as a sibling of `<Outlet/>`, not conditionally per-page, so the socket
 * connection survives navigation between pages in the same shell.
 */
export function NotificationSocketBridge() {
  useNotificationSocket()
  return null
}

export default NotificationSocketBridge
